<template lang="pug">
  Email(
    :emails_vet='vets',
    :emails_owners='owners',
    :auth_token='auth_token'
    :admin="user.role.slug == 'admin'"
  )
</template>

<script>
import { mapState } from "vuex";
import Email from '@/components/Email.vue'

export default {
  name: 'email_admin',
  components: {
    Email,
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      auth_token: state => state.auth.auth_token,
      vets: state => state.users.vets_without_pagination,
      owners: state => state.users.owners_without_pagination
    })
  },
  created () {
    this.$store.dispatch(
      "users/getUserWithoutPagination",
      {
        token: this.auth_token,
        vet: true,
        owner: false
      }
    );
    this.$store.dispatch(
      "users/getUserWithoutPagination",
      {
        token: this.auth_token,
        vet: false,
        owner: true
      }
    );
  },
}
</script>
